import React, { FC } from 'react';

interface SVGLinkedinIconProps {
  width?: string;
  height?: string;
  color?: string;
}

const SVGLinkedinIcon: FC<SVGLinkedinIconProps> = ({
  width = '32',
  height = '32',
  color = 'black',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0704 25.2459H7.40651V13.08H11.0878V25.2459H11.0704V25.2459ZM9.21232 11.4887C8.32304 11.496 7.51739 10.9537 7.17218 10.1157C6.82697 9.27759 7.01042 8.30934 7.63674 7.66376C8.26306 7.01818 9.20846 6.82287 10.0307 7.16919C10.853 7.51551 11.3897 8.33499 11.3897 9.24437C11.393 10.4783 10.419 11.4822 9.21232 11.4887ZM24.8897 25.2459H21.2084V18.8572C21.2084 17.1056 20.5581 16.1259 19.2052 16.1259C17.7304 16.1259 16.9639 17.1412 16.9639 18.8572V25.2459H13.4278V13.08H16.9581V14.7187C17.7287 13.4556 19.0908 12.6983 20.5465 12.7237C23.0665 12.7237 24.8723 14.2972 24.8723 17.5569L24.8897 25.2459Z"
      fill={color}
    />
  </svg>
);

export default SVGLinkedinIcon;
